import { Inject, Injectable } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services';
import { EnumInjectionTokens } from '../constants';
import { IEnvironment } from '../interfaces';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TokenRefreshInterceptor implements HttpInterceptor {
  constructor(
    private authStorage: OAuthStorage,
    private authService: AuthService,
    @Inject(EnumInjectionTokens.Environment) private environment: IEnvironment
  ) { }

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isApiUrl = req.url.toLocaleLowerCase().includes(this.environment.base.apiUrl.toLocaleLowerCase());

      return next.handle(req).pipe(
        catchError(error => {
          if (
            isApiUrl
            && error instanceof HttpErrorResponse
            && error.status === 401
          ) {
            return this.handle401();
          }

          return of(error);
        })
      )
  }

  private async handle401() {
    this.authStorage.removeItem('access_token');
    await this.authService.login();
  }
}